/** обязательный вариант для компонента Autocomplete*/
export const DEFAULT_OPTIONS_INVESTMENT_ID = { value: "", label: "Все" };
/** минимально возможная выбранная дата, на случай, если контрактов нет */
export const minPossibleDate = new Date(2007, 0, 1);
/** максимально возможная выбранная дата, на случай, если контрактов нет*/
export const maxPossibleDate = new Date();
maxPossibleDate.setDate(maxPossibleDate.getDate() - 1);
